import { render, staticRenderFns } from "./UcContractServiceCard.yaml?vue&type=template&id=79641494&component"
import script from "./UcContractServiceCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractServiceCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports